import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EngineOilFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M16.3088 17.6901H8.30164V8.7046L11.1058 5.90046H16.3088V17.6901ZM10.4139 11.426L9.33771 10.35L10.2293 9.45844L11.3054 10.5345H13.3048L14.3809 9.45844L15.2725 10.35L14.1963 11.4261V13.4254L15.2725 14.5016L14.3809 15.3931L13.3047 14.317H11.3055L10.2293 15.3931L9.33771 14.5016L10.4139 13.4255V11.426Z"
      />
      <path
        fillRule="evenodd"
        d="M7.89239 3.6001L8.78387 4.49152L6.89264 6.38269L6.00122 5.49127L7.89239 3.6001ZM6.63159 8.01288L10.414 4.23047L17.9788 4.23048V19.36H6.63159V8.01288ZM8.30164 17.6901H16.3088V5.90046H11.1058L8.30164 8.7046V17.6901Z"
      />
      <path d="M11.6539 11.7745H12.9563V13.0769H11.6539V11.7745Z" />
    </SvgIcon>
  );
});
